import api from './api';

export interface Asset {
  id: number;
  name: string;
  type:
  | 'domain'
  | 'subdomain'
  | 'ip_address'
  | 'email'
  | 'url'
  | 'social_media'
  | 'mobile_app'
  | 'certificate'
  | 'repository'
  | 'file'
  | 'other';
  value: string;
  description?: string;
  status: 'active' | 'inactive' | 'monitoring' | 'compromised' | 'unknown';
  criticality: 'low' | 'medium' | 'high' | 'critical';
  tags?: string[];
  company_id: number;
  created_at: string;
  updated_at?: string;
  last_seen?: string;
  discovered_by?: string;
}

export interface AssetCreate {
  name: string;
  type: Asset['type'];
  value: string;
  description?: string;
  criticality?: Asset['criticality'];
  tags?: string[];
  company_id: number;
}

export interface AssetUpdate {
  name?: string;
  description?: string;
  criticality?: Asset['criticality'];
  status?: Asset['status'];
  tags?: string[];
}

export interface AssetFilters {
  search?: string;
  asset_type?: Asset['type'];
  status?: Asset['status'];
  criticality?: Asset['criticality'];
  company_id?: number;
  skip?: number;
  limit?: number;
}

export interface AssetsSummary {
  total_assets: number;
  by_type: Record<string, number>;
  by_status: Record<string, number>;
  by_criticality: Record<string, number>;
}

export const assetsService = {
  // Listar ativos
  async getAssets(filters: AssetFilters = {}): Promise<Asset[]> {
    const params = new URLSearchParams();

    Object.keys(filters).forEach((key) => {
      const value = (filters as any)[key];
      if (value !== undefined && value !== null) {
        params.append(key, value.toString());
      }
    });

    const response = await api.get(`/api/v2/assets/?${params.toString()}`);
    return response.data;
  },

  // Obter ativo específico
  async getAsset(id: number): Promise<Asset> {
    const response = await api.get(`/api/v2/assets/${id}`);
    return response.data;
  },

  // Criar novo ativo
  async createAsset(asset: AssetCreate): Promise<Asset> {
    const response = await api.post('/api/v2/assets/', asset);
    return response.data;
  },

  // Atualizar ativo
  async updateAsset(id: number, asset: AssetUpdate): Promise<Asset> {
    const response = await api.put(`/api/v2/assets/${id}`, asset);
    return response.data;
  },

  // Deletar ativo
  async deleteAsset(id: number): Promise<void> {
    await api.delete(`/api/v2/assets/${id}`);
  },

  // Obter resumo estatístico
  async getAssetsSummary(company_id?: number): Promise<AssetsSummary> {
    const params = new URLSearchParams();
    if (company_id !== undefined) {
      params.append('company_id', company_id.toString());
    }

    const url = params.toString()
      ? `/api/v2/assets/stats/summary?${params.toString()}`
      : '/api/v2/assets/stats/summary';
    const response = await api.get(url);
    return response.data;
  },
};
